import { ToastInfo } from '@/components/molecules/ToastTemplate/ToastTemplate';

/** Warns that a lice report range is longer than the report allows; `message` is translated. */
export function showLiceReportRangeExceededToast(message: string): void {
    ToastInfo({
        content: message,
        page: 'lice-report',
        position: 'top-right',
        icon: 'lice',
        status: 'warning',
        type: 'warning',
    });
}
